export const GET_DATA_USERS  = 'GET_DATA_USERS';
export const SET_DATA_USERS  = 'SET_DATA_USERS';
export const ERROR_DATA_USERS  = 'ERROR_DATA_USERS';
export const SET_LOGIN  = 'SET_LOGIN';
export const SET_DRAWER  = 'SET_DRAWER';